import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useAuthContext } from '@/contexts/auth/AuthContext';

const NotFound = () => {
  const { user } = useAuthContext();
  
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="max-w-md w-full mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
        <div className="p-8">
          <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-center mb-4">Page non trouvée</h1>
          <p className="text-gray-600 text-center mb-8">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <div className="flex justify-center">
            <Button asChild>
              <Link to={user ? "/dashboard" : "/"}>
                {user ? "Retourner au tableau de bord" : "Retourner à l'accueil"}
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
